import { styled } from "theme/default/styled";
import { setColor_69809a } from "theme/setter/setColorsValues/setColor_69809a";

export const SRightControlsTitle = styled.div`
  margin: 0 8px;

  ${setColor_69809a};
`;
